/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteLadderResponse
 */
export interface DeleteLadderResponse {
    /**
     * 
     * @type {boolean}
     * @memberof DeleteLadderResponse
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof DeleteLadderResponse
     */
    message: string;
}

/**
 * Check if a given object implements the DeleteLadderResponse interface.
 */
export function instanceOfDeleteLadderResponse(value: object): value is DeleteLadderResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function DeleteLadderResponseFromJSON(json: any): DeleteLadderResponse {
    return DeleteLadderResponseFromJSONTyped(json, false);
}

export function DeleteLadderResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteLadderResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'message': json['message'],
    };
}

export function DeleteLadderResponseToJSON(json: any): DeleteLadderResponse {
    return DeleteLadderResponseToJSONTyped(json, false);
}

export function DeleteLadderResponseToJSONTyped(value?: DeleteLadderResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
    };
}

